export type AccessLevel = 'FREE' | 'SUBSCRIBERS_ONLY' | 'PAY_PER_VIEW' | 'SUBSCRIBERS_OR_PPV'

export function accessLabel(level: AccessLevel, ppvPricePixe?: number | null, requiredTierRank?: number | null): string {
  if (level === 'FREE') return 'Free'
  if (level === 'SUBSCRIBERS_ONLY') return requiredTierRank && requiredTierRank > 1 ? `Tier ${requiredTierRank}+` : 'Subscribers'
  if (level === 'PAY_PER_VIEW') return `PPV${ppvPricePixe ? ` ${ppvPricePixe}` : ''}`
  const base = requiredTierRank && requiredTierRank > 1 ? `Tier ${requiredTierRank}+ or PPV` : 'Subs or PPV'
  return `${base}${ppvPricePixe ? ` ${ppvPricePixe}` : ''}`
}

export function isPaidAccess(level: AccessLevel, requiredTierRank?: number | null): boolean {
  return level !== 'FREE' || (!!requiredTierRank && requiredTierRank > 1)
}

export function paidBadgeLabel(level: AccessLevel, requiredTierRank?: number | null): string | null {
  return isPaidAccess(level, requiredTierRank) ? 'Paid' : null
}

export function accessRequiresPPV(level: AccessLevel): boolean {
  return level === 'PAY_PER_VIEW' || level === 'SUBSCRIBERS_OR_PPV'
}

export function isAccessOptionDisabled(opts: {
  option: AccessLevel
  subsEnabled: boolean
  ppvAllowed: boolean
}): boolean {
  const { option, subsEnabled, ppvAllowed } = opts
  if (option === 'FREE') return false
  if (!subsEnabled) return true
  if ((option === 'PAY_PER_VIEW' || option === 'SUBSCRIBERS_OR_PPV') && !ppvAllowed) return true
  return false
}

export function normalizeAccessSelection(opts: {
  level: AccessLevel
  subsEnabled: boolean
  ppvAllowed: boolean
}): AccessLevel {
  const { level, subsEnabled, ppvAllowed } = opts
  if (level === 'FREE') return 'FREE'
  if (!subsEnabled) return 'FREE'
  if ((level === 'PAY_PER_VIEW' || level === 'SUBSCRIBERS_OR_PPV') && !ppvAllowed) return 'SUBSCRIBERS_ONLY'
  return level
}
